import React, { useState } from 'react';

import styles from './css/UnmanagedInputContainer.module.css';

const UnmanagedInputContainer = ({ entityType, addUnmanagedEntity, showExcluded, disableAdd = false }) => {
    const [entityName, setEntityName] = useState('');

    const onNameChanged = (event) => {
        setEntityName(event.target.value);
    };

    const onAddClicked = (excluded) => {
        if (!entityName.trim()) {
            return;
        }

        const newEntity = {
            name: entityName,
            excluded: excluded,
            unmanaged: true,
            type: entityType
        };
        const isAdded = addUnmanagedEntity(newEntity);
        if (isAdded) {
            setEntityName('');
        }
    };

    return (
        <div className={styles.newNameContainer}>
            <input
                key={`${entityName}`}
                value={entityName}
                name="entityName"
                className={styles.name}
                type="text"
                onChange={(event) => {
                    onNameChanged(event);
                }}
                onKeyPress={(event) => event.key === 'Enter' && onAddClicked(disableAdd)}
                autoFocus={true}
            />
            <div className={styles.buttons}>
                {!disableAdd && (
                    <div onClick={() => onAddClicked(false)} className={styles.nameAddButton}>
                        <i className="fa fa-plus-circle"></i> Add
                    </div>
                )}
                {showExcluded && (
                    <div onClick={() => onAddClicked(true)} className={styles.nameExcludeButton}>
                        <i className="fa fa-minus-circle"></i> Exclude
                    </div>
                )}
            </div>
        </div>
    );
};

export default UnmanagedInputContainer;
